import {combineReducers} from 'redux'
import types from 'actions/types'
import {get, isNil} from 'lodash'
import {createPivotTableReducer} from 'reducers/pivotTable'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_DELIVERY_NOTE_DIALOG:
      return true
    case types.HIDE_DELIVERY_NOTE_DIALOG:
      return false
    case types.DELIVERY_NOTE_DIALOG_INITIALISE_FAILURE:
      return false
    default:
      return state
  }
}

export const deliveryNote = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_DELIVERY_NOTE_DIALOG:
      return get(action, 'deliveryNote', null)
    case types.HIDE_DELIVERY_NOTE_DIALOG:
      return null
    case types.DELIVERIES_ADD_DELIVERY_NOTE_SUCCESS:
      return action.deliveryNote
    case types.DELIVERIES_UPDATE_DELIVERY_NOTE_SUCCESS:
      return action.deliveryNote
    default:
      return state
  }
}

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_DELIVERY_NOTE_DIALOG:
    case types.DELIVERY_NOTE_DIALOG_INITIALISE_ATTEMPT:
      return true
    case types.HIDE_DELIVERY_NOTE_DIALOG:
    case types.DELIVERY_NOTE_DIALOG_INITIALISE_SUCCESS:
    case types.DELIVERY_NOTE_DIALOG_INITIALISE_FAILURE:
      return false
    default:
      return state
  }
}

export const isSaving = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_DELIVERY_NOTE_DIALOG:
    case types.HIDE_DELIVERY_NOTE_DIALOG:
      return false
    case types.DELIVERIES_ADD_DELIVERY_NOTE_ATTEMPT:
      return true
    case types.DELIVERIES_UPDATE_DELIVERY_NOTE_ATTEMPT:
      return !action.isBackground
    case types.DELIVERIES_ADD_DELIVERY_NOTE_SUCCESS:
    case types.DELIVERIES_ADD_DELIVERY_NOTE_FAILURE:
    case types.DELIVERIES_UPDATE_DELIVERY_NOTE_SUCCESS:
    case types.DELIVERIES_UPDATE_DELIVERY_NOTE_FAILURE:
      return false
    default:
      return state
  }
}

export const orderId = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_DELIVERY_NOTE_DIALOG:
      return isNil(action.deliveryNote)
        ? action.orderId
        : action.deliveryNote.orderId
    case types.HIDE_DELIVERY_NOTE_DIALOG:
      return null
    default:
      return state
  }
}

export const returnNote = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_DELIVERY_NOTE_DIALOG:
      return isNil(action.deliveryNote)
        ? action.returnNote
        : action.deliveryNote.returnNote
    case types.HIDE_DELIVERY_NOTE_DIALOG:
      return false
    default:
      return state
  }
}

export const order = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_DELIVERY_NOTE_DIALOG:
    case types.HIDE_DELIVERY_NOTE_DIALOG:
      return null
    case types.DELIVERY_NOTE_DIALOG_INITIALISE_SUCCESS:
      return action.order
    default:
      return state
  }
}

export const deletedItems = (state = [], action) => {
  switch (action.type) {
    case types.SHOW_DELIVERY_NOTE_DIALOG:
    case types.HIDE_DELIVERY_NOTE_DIALOG:
      return []
    case types.DELIVERY_NOTE_DIALOG_DELETE_ITEMS:
      return [
        ...state,
        ...action.deliveryNoteItems
          .filter(deliveryNoteItem => !deliveryNoteItem.isNew)
          .map(deliveryNoteItem => deliveryNoteItem.id),
      ]
    case types.DELIVERIES_ADD_DELIVERY_NOTE_SUCCESS:
    case types.DELIVERIES_UPDATE_DELIVERY_NOTE_SUCCESS:
      return []
    default:
      return state
  }
}

export const deleteFailedPrompt = (state = {}, action) => {
  switch (action.type) {
    case types.SHOW_DELETE_DELIVERY_NOTE_FAILURE_PROMPT:
      return {
        ...state,
        isDeleteFailedPromptVisible: true,
        deleteFailedMessage: action.message,
      }
    case types.HIDE_DELETE_DELIVERY_NOTE_FAILURE_PROMPT:
      return {
        ...state,
        isDeleteFailedPromptVisible: false,
        deleteFailedMessage: null,
      }
    default:
      return state
  }
}

export const itemsPivotTableKey = 'dialogs.deliveryNote.items'
export const returnItemsPivotTableKey = 'dialogs.deliveryNote.returnItems'

export default combineReducers({
  isVisible,
  isLoading,
  isSaving,
  deliveryNote,
  orderId,
  returnNote,
  order,
  items: createPivotTableReducer({key: itemsPivotTableKey, defaultSortColumn: 'itemId'}),
  returnItems: createPivotTableReducer({key: returnItemsPivotTableKey, defaultSortColumn: 'itemId'}),
  deletedItems,
  deleteFailedPrompt,
})
